
import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';
import { IncidentCategoryService } from '../../../core/services/incident-category.service';
import { FocalPointMapEntityService } from '../../../core/services/focal-point-map-entity.service';
import { CoreService } from '../../../core/services/core.service';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { FixedPerimeterCreationOptions, FocalPoint } from '../../../core/models/fixed-perimeter.models';
import { DataContextService } from '../../../core/services/data-context.service';
import { PinActivationService } from '../../../core/services/pin-activation.service';
import { CoresService } from '../../../core/services/cores.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CameraService } from '../../../core/services/camera.service';
import { TimelineService } from '../../../core/services/timeline.service';
import { WindowService } from '../../../core/services/window.service';

@Component({
  selector: 'app-fixed-perimeter-creator-button',
  standalone: true,
  imports: [],
  templateUrl: './fixed-perimeter-creator-button.component.html',
  styleUrl: './fixed-perimeter-creator-button.component.css'
})
export class FixedPerimeterCreatorButtonComponent implements OnInit {
  @Input() creationId!: number;
  @Output() close = new EventEmitter<void>();
  @Output() openPinDialog = new EventEmitter<any>();

  options?: FixedPerimeterCreationOptions;
  focalPoint?: FocalPoint;
  focalPointText = 'Set Focal Point';
  focalPointDivMessage = 'In order to set focal point click on <strong>Set Focal Point</strong> or <strong>Continue</strong> to skip.';
  showAddFocalPoint = false;
  tempFocalPointEntity: any;

  showPinDialog = false;
  pinDialogData: any = null; // Optionally pass data to the dialog
  isToolActive = false;
  constructor(
    private incidentCategoryService: IncidentCategoryService,
    private focalPointMapEntityService: FocalPointMapEntityService,
    private core: CoreService,
    private coreService :CoresService,
    private arcAngelService: ArcAngelService,
     private dataContextService: DataContextService ,
    private organizationUtilService: OrganizationUtilService,
    private pinActivationService : PinActivationService,
    private cameraService : CameraService,
    private windowService: WindowService,
    private modalService: NgbModal,
    private timelineService: TimelineService
  ) {}

  ngOnInit(): void {
    this.options = this.incidentCategoryService.getFixedPerimeterCreationOptions(this.creationId);
    this.showSetFocal();

    // Get the perimeter entity from OrganizationUtilService
    let perimeterData: any = undefined;
    if (this.options && this.options.basePerimeterId !== undefined) {
      perimeterData = this.organizationUtilService.perimeters?.[this.options.basePerimeterId];
    }
    this.showAndGoToPerimeter(perimeterData);
  }

  showSetFocal() {
    this.showAddFocalPoint = false;
  }

  showAddFocal() {
    this.showAddFocalPoint = true;
  }

  setFocalPointButtonClicked(): void {
    this.showAddFocal();
    this.core.setToolActive(true);
    this.core.addGlobeClickListener('fixedperimetercreatorbutton', (lat: number, lon: number) => {
      try {
        this.core.removeGlobeClickListener('fixedperimetercreatorbutton');
        this.core.setToolActive(false);
        if (this.tempFocalPointEntity) {
          this.dataContextService.removeMapEntity(this.tempFocalPointEntity);
          this.tempFocalPointEntity = undefined;
        }
        this.focalPoint = {
          type: 'Point',
          coordinates: [lon, lat]
        };
        this.tempFocalPointEntity = this.focalPointMapEntityService.createFocalPointEntity(this.focalPoint, new Date(), this.cameraService, this.core, this.windowService, this.dataContextService, this.modalService, this.timelineService);
          this.dataContextService.addMapEntity(this.tempFocalPointEntity);
        this.finishedFocalPointClicked();
      } catch (e) {
        console.error('Error in globe click callback:', e);
      }
    });
  }

  continueButtonClicked(): void {
    this.finishDrawing(this.focalPoint);
  }

  finishedFocalPointClicked(): void {
    this.focalPointText = 'Reset Focal Point';
    this.focalPointDivMessage = 'In order to Reset focal point click on <strong>Reset Focal Point</strong> or <strong>Continue</strong> to skip.';
    this.showSetFocal();
  }

  cancelFocalPointClicked(): void {
    this.showSetFocal();
    this.focalPoint = undefined;
    this.core.setToolActive(false);
  }

  onCancelClicked(): void {
    this.cleanup();
    this.close.emit();
    this.incidentCategoryService.notifyClosedFixedPerimCreator();
    this.core.setToolActive(false);
  }

  private cleanup(): void {
    this.core.removeGlobeClickListener('fixedperimetercreatorbutton');
    if (this.tempFocalPointEntity) {
      this.dataContextService.removeMapEntity(this.tempFocalPointEntity);
      this.tempFocalPointEntity = undefined;
    }
    // Remove perimeter entity if you added it
    // this.dataContextService.removeMapEntity(perimeterData);
  }

  // private finishDrawing(focalPoint?: FocalPoint): void {
  //   if (!this.options) return;
  //   // Optionally prepare data for the dialog
  //   this.pinDialogData = {
  //     orgId: this.options.organizationId,
  //     perimeterId: this.options.basePerimeterId,
  //     label: this.options.label,
  //     description: this.options.description,
  //     includeFloors: true,
  //     focalPoint: focalPoint,
  //     incidentCategoryId: this.options.incidentCategoryId
  //   };
  //   this.showPinDialog = true;
  // }
  
 private finishDrawing(focalPoint?: FocalPoint): void {
    if (!this.options) return;
    const obj = {
      orgId: this.options.organizationId,
      perimeterId: this.options.basePerimeterId,
      label: this.options.label,
      description: this.options.description,
      includeFloors: true,
      focalPoint: focalPoint,
      incidentCategoryId: this.options.incidentCategoryId
    };

    this.incidentCategoryService.createIncidentFromPerimeter(obj).subscribe(dialogData => {
      this.openPinDialog.emit(dialogData);
      this.close.emit(); 
    });
  }

  private showAndGoToPerimeter(perimeterData: any): void {
    if (!perimeterData) return;
    // Set 2D view flag if needed
    perimeterData.showIn2d = true;
    // Show the perimeter entity (implement these methods as needed)
    if (typeof perimeterData.show === 'function') {
      perimeterData.show();
    }
    if (typeof perimeterData.goToEntity === 'function') {
      perimeterData.goToEntity();
    }
    this.core.addMorphCompleteListener('incidentperimeter', () => {
      this.core.removeMorphCompleteListener('incidentperimeter');
      if (typeof perimeterData.goToEntity === 'function') {
        perimeterData.goToEntity();
      }
    });
  }

}
